import React from 'react';

const ToggleSwitch = ({ isOn, onToggle }: { isOn: boolean; onToggle: () => void }) => (
  <div
    className={`w-10 h-5 flex items-center bg-gray-600 rounded-full p-1 cursor-pointer transition-colors ${isOn ? 'bg-green-500' : 'bg-gray-600'}`}
    onClick={onToggle}
  >
    <div className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform ${isOn ? 'translate-x-5' : 'translate-x-0'}`} />
  </div>
);

export default ToggleSwitch;